<template>
  <div class="label-row d-flex align-center justify-space-between pb-1">
    <label class="form-label-text">{{ label }}</label>
    <div
      v-if="showSelectAll && searchQuery.length > 2 && currentOptions?.length"
      :class="['select-all', allAreSelected ? 'checked' : '', 'pr-2']"
      @click="$emit('selectAll')"
    >
      Select All
    </div>
  </div>
</template>

<script setup>
defineProps({
  searchQuery: {
    type: String,
    default: '',
  },
  currentOptions: {
    type: Array,
    default: () => [],
  },
  allAreSelected: {
    type: Boolean,
    default: false,
  },
  showSelectAll: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
});

defineEmits(['selectAll']);
</script>

<style lang="less" scoped>
.label-row {
  width: 100%;
}

.select-all {
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  &:hover {
    color: @text-brand;
  }
}

.checked {
  color: @text-brand;
}
</style>
